import jwtAxios from '@nxsys/services/axios';
import { endPoints } from '@nxsys/services/endpoints';
import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  CreateAssignmentParams,
  CreateAssignmentResponse,
  DeleteAssignmentByIdParams,
  DeleteAssignmentByIdResponse,
  GetAssignmentByIdParams,
  GetAssignmentByIdResponse,
  GetAssignmentListParams,
  GetAssignmentListResponse,
  UpdateAssignmentByIdParams,
  UpdateAssignmentByIdResponse,
} from '../types';

export const getAssignmentList = createAsyncThunk<
  GetAssignmentListResponse,
  GetAssignmentListParams
>(
  'assignment/getAssignmentList',
  async (params: GetAssignmentListParams, { rejectWithValue }) => {
    try {
      const response = await jwtAxios.get(endPoints.assignments, {
        params,
      });
      return {
        data: response.data.data,
        pagination: {
          current: params.page || 0,
          pageSize: params.size || 20,
          totalDocs: response.data.totalDocs,
        },
        queryParams: params,
      };
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const getAssignmentById = createAsyncThunk<
  GetAssignmentByIdResponse,
  GetAssignmentByIdParams
>(
  'assignment/getAssignmentById',
  async (params: GetAssignmentByIdParams, { rejectWithValue }) => {
    try {
      const response = await jwtAxios.get(
        `${endPoints.assignments}/${params.id}`,
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const createAssignment = createAsyncThunk<
  CreateAssignmentResponse,
  CreateAssignmentParams
>(
  'assignment/CreateAssignmentParams',
  async (params: CreateAssignmentParams, { rejectWithValue }) => {
    try {
      const response = await jwtAxios.post(endPoints.assignments, params);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const updateAssignmentById = createAsyncThunk<
  UpdateAssignmentByIdResponse,
  UpdateAssignmentByIdParams
>(
  'assignment/updateAssignmentById',
  async (params: UpdateAssignmentByIdParams, { rejectWithValue }) => {
    try {
      const response = await jwtAxios.put(`${endPoints.assignments}/${params.id}`, params.payload);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const deleteAssignmentById = createAsyncThunk<
  DeleteAssignmentByIdResponse,
  DeleteAssignmentByIdParams
>(
  'assignment/deleteAssignmentById',
  async (params: DeleteAssignmentByIdParams, { rejectWithValue }) => {
    try {
      const response = await jwtAxios.delete(
        `${endPoints.assignments}/${params.id}`,
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const assignmentActs = {
  getAssignmentList,
  getAssignmentById,
  createAssignment,
  updateAssignmentById,
  deleteAssignmentById,
};
